import {Component, Input, OnDestroy, OnInit} from '@angular/core';
import {NgbActiveModal, NgbDateStruct, NgbInputDatepicker} from '@ng-bootstrap/ng-bootstrap';
import {TranslateModule} from '@ngx-translate/core';
import {FormsModule} from '@angular/forms';
import {NgForOf, NgIf} from '@angular/common';
import {Subscription} from "rxjs";
import {PlanningRegionApiService} from "../../../../services/api/planning-region-api.service";
import {ToastService} from "../../../../services/toaster.service";
import {dateUtils} from "../../../../helpers/date.utils";
import {BaseComponent} from "../../../base/base.component";
import {ScreenComment} from "../../../../models/screen.model";


@Component({
  selector: 'app-screen-comment-modal',
  templateUrl: './planning-region-screen-comment-modal.component.html',
  styleUrls: ['./planning-region-screen-comment-modal.component.scss'],
  standalone: true,
  imports: [TranslateModule, FormsModule, NgIf, NgForOf, NgbInputDatepicker]
})
export class ScreenCommentModalComponent extends BaseComponent implements OnInit, OnDestroy {
  @Input() screenId!: number;
  @Input() liv_ville!: string | undefined;
  @Input() nom_cinema!: string | undefined;
  @Input() date!: NgbDateStruct;
  @Input() comments: ScreenComment[] = [];

  comment: string = '';
  startDate: NgbDateStruct | null = null;
  endDate: NgbDateStruct | null = null;

  private subscriptions: Subscription = new Subscription();

  constructor(
    public activeModal: NgbActiveModal,
    private planningRegionApiService: PlanningRegionApiService,
    private toastService: ToastService,
  ) {
    super();
  }

  ngOnInit(): void {
    this.initializeForm();
  }

  ngOnDestroy(): void {
    this.subscriptions.unsubscribe();
  }

  initializeForm(): void {
    this.startDate = this.date;
    this.endDate = this.date;
  }

  saveComment(): void {
    if (!this.startDate || !this.endDate) {
      return;
    }

    const newComment: any = {
      screen_id: this.screenId,
      commentaire: this.comment,
      date_debut: dateUtils.formatDateStruct(dateUtils.toDate(this.startDate)),
      date_fin: dateUtils.formatDateStruct(dateUtils.toDate(this.endDate)),
    };
    const subscription = this.planningRegionApiService.saveComment(this.cookies, newComment)
      .subscribe(
        (comment) => {
          this.toastService.showSuccess('toast.success');
          this.resetForm();
          newComment['id_comm'] = comment.id_commentaire;
          this.comments.push(newComment);
          this.planningRegionApiService.reloadPlanningRegion(this.idRegion);
          this.closeModal()
        },
        () => this.toastService.showDanger('toast.error')
      );
    this.subscriptions.add(subscription);
  }

  deleteComment(idComment: number): void {
    const subscription = this.planningRegionApiService.deleteComment(this.cookies, idComment)
      .subscribe(
        () => {
          this.toastService.showSuccess('toast.success');
          this.comments = this.comments.filter(comment => comment.id_comm !== idComment);
          this.planningRegionApiService.reloadPlanningRegion(this.idRegion);
          this.closeModal()
        },
        () => this.toastService.showDanger('toast.error')
      );
    this.subscriptions.add(subscription);
  }

  resetForm(): void {
    this.comment = '';
    this.initializeForm();
  }

  closeModal(): void {
    this.activeModal.close();
  }
}
